import React, { useEffect, useState } from 'react';
import BodyStep from '../../components/BodyStep';
import ForceChangePasswordModal from '../../components/ForceChangePasswordModal';
import OptIn from '../../components/OptIn';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';

const Balcao: React.FC = () => {
  const { changeStep } = useSteps();
  const { companyName, optin } = useAuth();
  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('mustChangePassword') === '1') {
      setShowChangePassword(true);
    }
  }, []);

  return (
    <>
      {optin === 0 && <OptIn />}
      {companyName ? <BodyStep>{changeStep()}</BodyStep> : <>{changeStep()}</>}
      <ForceChangePasswordModal
        isOpen={showChangePassword}
        onClose={() => setShowChangePassword(false)}
      />
    </>
  );
};

export default Balcao;
